import {
    RepositoryActionType,
    type RepositoryAction,
    type RepositoryState
} from "./types";

export const reducer = <TRepositoryState extends RepositoryState>(stateFactory: () => TRepositoryState) =>
    (state: TRepositoryState, action: RepositoryAction<TRepositoryState>) => {
        switch (action.type) {
            case RepositoryActionType.Fetch: {
                return {
                    ...state,
                    ...action.payload
                };
            }

            case RepositoryActionType.Reset: {
                return stateFactory();
            }

            default:
                return state;
        }
    };

export default reducer;
